import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import { CallService } from './-call.service';

const API = `${environment.api}/api`;

@Injectable({
  providedIn: 'root'
})
export class ActualiteService {

  constructor(private http: HttpClient, private callService: CallService) { }

  getActualites(): Observable<any> {
    const httpOptions = this.callService.getHTTPOptionWithoutToken();
    return this.http.get(API + '/actualites/displayed', httpOptions);
  }

  getActualite(slug: string): Observable<any> {
    const httpOptions = this.callService.getHTTPOptionWithoutToken();
    return this.http.get(API + '/actualites/displayed/' + slug, httpOptions);
  }
}
